<template>
    <ValidationProvider v-slot="{ errors }" name="UMR" rules="required">
      <AdvancedDropdown
        v-model="modelValue"
        v-bind="$attrs"
        :options="umrOptions"
        :disabled="false"
        :can-add-new="false"
        label="UMR"
        size="sm"
      >
        <template v-slot:label> UMR <span class="text-danger">*</span> </template>
  
        <template v-slot:button-content>
          <template v-if="!!selectedUMR">{{ selectedUMR.text }}</template>
          <template v-else>Select</template>
        </template> 

      </AdvancedDropdown>
  
      <div v-if="!!errors.length" class="invalid-feedback d-block">
        {{ errors[0] }}
      </div>
    </ValidationProvider>
  </template>
  
  <script>
import { ValidationProvider } from 'vee-validate'
import { BaseIcon } from '@components/base'
import { AdvancedDropdown } from '@components/advanced'
import { userMixin } from '@mixins'
import reportsService from '../../services/reportsService'

export default {
  name: 'CashCallFormUMR',
  components: { ValidationProvider, BaseIcon, AdvancedDropdown },
  mixins: [userMixin],
  props: {
    // must stay as Array, since AdvancedDropdown expects Array
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      umrOptions: []
    }
  },
  computed: {
    modelValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    // convenience helper: unwrap the single value
    selectedUMR() {
      const val = this.value[0]
      if (!val) return null
        // find the corresponding option object
        return this.umrOptions.find(opt => opt.value === val) || null
    }
  },
  methods: {
    async getParameters(params = null, flags = null, umrCriteria = 'Active') {
      const data = {
        company_id: this.userCompanyId,
        role: this.userCompanyRole,
        role_value: this.userCompanyRoleValue,
        umr_criteria: umrCriteria,
        uw_option: 'Lead'
      }

      try {
        const response = await reportsService.getExportParametersV2(data)
        const parameters = response.data.data.data
        this.umrOptions = parameters.UMR_Risk_Cat_Section.map(key => ({
          text: key,
          value: key
        }))
      } catch (err) {
        console.error('Error fetching UMRs', err)
      }
    }
  },
  mounted() {
    this.getParameters()
  }
}
</script>


  
  <style scoped>
  .advanced-dropdown >>> .dropdown-toggle {
    max-width: 214px;
  }
  
  .advanced-dropdown >>> .dropdown-menu .list-group-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  .advanced-dropdown >>> .dropdown-menu .list-group-item.disabled {
    color: #fff;
    background-color: #1c4a50;
    pointer-events: initial;
  }
  </style>
  